import { ShelfSeciton } from './ShelfSeciton'
import { withShelfSeciton } from './withShelfSeciton'

const ConnectedShelfSeciton = withShelfSeciton(ShelfSeciton)
export { ConnectedShelfSeciton as ShelfSeciton }
